import { t } from '@lingui/macro';
import { Location, useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { Button, ParagraphMd } from '@olist/design-system';

import { PageLayout } from 'components';
import { ButtonWrapper, Logos, Title } from 'components/general';
import { OlistEmail } from 'components/icons/appLogos';
import useMixPanel from 'hooks/use-mixpanel';

export default function RequestRecoverySent() {
  interface StateType {
    values: { email: string; redirect_type: string };
  }

  interface ExtendedLocation extends Location {
    state: StateType;
  }

  const [searchParams] = useSearchParams();
  const { state } = useLocation() as ExtendedLocation;
  const values = state ? state.values : { email: 'o seu e-mail' };
  const redirectType = searchParams.get('redirect_type');
  const navigate = useNavigate();
  const { track } = useMixPanel(false);

  const textTitle = redirectType === '1' ? 'Senha Expirada' : 'Confira seu e-mail';

  return (
    <PageLayout>
      <section>
        <Logos>
          <OlistEmail />
        </Logos>
        <Title>{textTitle}</Title>
        {redirectType === '1' && (
          <ParagraphMd>
            {t`Your account password has expired. Change your password and get access to our tool again!`}
          </ParagraphMd>
        )}
        <br />
        <ParagraphMd>
          {t`Instructions for resetting your password have been sent to`}&nbsp;{values.email}.
        </ParagraphMd>
        <br />
        <ParagraphMd>{t`Don't forget to also check your email spam folder.`}</ParagraphMd>
        <br />
        <ParagraphMd>
          {t`If you do not receive the email within 10 minutes, repeat the previous step to request a resend.`}
        </ParagraphMd>
        <br />
        <ParagraphMd>
          {t`If you have any difficulties, please contact exchange_senha@olist.com.`}
        </ParagraphMd>
        <ButtonWrapper>
          <Button
            fixed
            variation="secondary"
            size="medium"
            onClick={() => {
              track('Request Recovery Sent - Clicked on Return to Login');
              navigate('/auth/login');
            }}
            className="button"
          >
            {t`return`}
          </Button>
        </ButtonWrapper>
      </section>
    </PageLayout>
  );
}
